export enum RouteName {
  Home = 'home',
  Subject = 'subject',
  Topic = 'topic',
  TopicGuide = 'topicGuide',
  SubjectContent = 'subjectContent',
  SubjectGuide = 'subjectGuide',
  SubjectResource = 'subjectResource',
  SubjectResourceTeacherBank = 'subjectResourceTeacherBank',
  CollectionTask = 'collectionTask',
}
